<template>
  <div class="cart-page__empty-content">
    <div class="cart-page__empty-wrap">
      <div class="cart-page__empty-icon">
        <EmptyCartIcon/>
      </div>
      <div class="cart-page__empty-text">
        <h4 class="cart-page__empty-title h3">
          Ваша корзина пуста
        </h4>

        <!--            <div class="cart-page__empty-subtitle text text__main">-->
        <!--              Перейдите в каталог для выбора товаров-->
        <!--            </div>-->
      </div>

      <a href="/catalog/tyres" class="cart-page__empty-button button button__ellipse button_yellow texts texts_button">
        В каталог
      </a>
    </div>
  </div>
</template>

<script>
import EmptyCartIcon from "../icons/EmptyCartIcon.vue";

export default {
  name: "TheCartEmpty",
  components: {EmptyCartIcon},
}
</script>
